import "./style.less";
export default function UserBooking() {
    return {
        restrict: "E",
        scope: {
            booking: "=",
            bookingResources: "<",
        },

        template: require("./template.html"),

        controller: function (
            $scope,
            BasketFixedUrl,
            Bookings,
            moment,
            ENV,
            $q,
            Basket
        ) {
            $scope.env = angular.copy(ENV);

            const booking = $scope.booking;
            $scope.activity = {};

            $scope.booking.bookingPeriods.forEach((bp) => {
                $scope.activity = bp.activity; // assumes that activity is the same for all bp in booking
            });

            $scope.deleteIncompletedBps = (booking) => {
                booking.bookingPeriods.map((bp) => {
                    if (bp.status == "New") {
                        deleteBookingPeriod(bp);
                    }
                });
            };

            const deleteBookingPeriod = (bp) => {
                return Bookings.deleteBookingPeriod(bp);
            };

            const isFixedBooking = (booking) => {
                // Order by start date decending
                booking.bookingPeriods = sortByTime(booking.bookingPeriods);

                // Grap the last fixed booking period
                const lastFixedBooking = booking.bookingPeriods.find(
                    (x) => x.status == "Completed" && x.bookingTypeId == 11
                );

                // Only show "renew" button if the last fixed booking is in the future
                if (
                    lastFixedBooking &&
                    moment(lastFixedBooking.start).isAfter()
                ) {
                    return true;
                }

                return false;
            };

            $scope.renewFixedBooking = (booking) => {
                // Delete all non-completed booking periods
                const promises = booking.bookingPeriods
                    .filter((x) => x.status == "New")
                    .map((bp) => Bookings.deleteBookingPeriod(bp));

                $q.all(promises).then(() => {
                    // Order by start date decending
                    booking.bookingPeriods = sortByTime(booking.bookingPeriods);

                    // Grap the last fixed booking period
                    const lastFixedBooking = booking.bookingPeriods.find(
                        (x) => x.status == "Completed" && x.bookingTypeId == 11
                    );

                    // Clear basket and reuse existing booking
                    Basket.resetBasket();
                    Basket.setBookingId(booking.id);

                    // basket-fixed?locationId=73&start=2021-02-03&weeks=5&activi[…]urceId=722&isFixed=true&startTime=09:00:00&endTime=10:00:00
                    BasketFixedUrl.setRoute(
                        lastFixedBooking.resource.locationId,
                        moment(lastFixedBooking.start).format("YYYY-MM-DD"),
                        5, // weeks
                        lastFixedBooking.activityId,
                        lastFixedBooking.resourceId,
                        true, // isFixed
                        moment(lastFixedBooking.start).format("HH:mm:ss"),
                        moment(lastFixedBooking.end).format("HH:mm:ss")
                    );
                });
            };

            /**
             * used to calc total price
             * @param {array} bpEntries
             */

            const eSum = (bpEntries) => {
                // var total = 0; // reset and recalculate total price
                let total = 0;

                bpEntries.forEach((bpe) => {
                    total += bpe.price * bpe.amount;
                });

                return total;
            };

            /**
             * used to calc total price
             * @param {array} bookingPeriods
             */
            const bpSum = (bookingPeriods) => {
                // var total = 0; // reset and recalculate total price
                let total = 0;
                bookingPeriods.forEach((bp) => {
                    total += bp.price;
                    total += bp.bookingPeriodEntries
                        ? eSum(bp.bookingPeriodEntries)
                        : 0;
                });

                return total;
            };

            const sortByTime = (periods) => {
                return periods.sort(function (a, b) {
                    return new Date(b.start) - new Date(a.start);
                });
            };

            /**
             * used to calc total sum of cancelled bps + entries
             * @param {array} bookingPeriods
             */
            const bpSumCancelled = (bookingPeriods) => {
                // var total = 0; // reset and recalculate total price
                let total = 0;
                bookingPeriods.forEach((bp) => {
                    if (bp.status == "Cancel") {
                        total += bp.price;
                        total += bp.bookingPeriodEntries
                            ? eSum(bp.bookingPeriodEntries)
                            : 0;
                    }
                });

                return total;
            };

            $scope.total = bpSum(booking.bookingPeriods);
            $scope.totalCancelled = bpSumCancelled(booking.bookingPeriods);
            $scope.isFixedBooking = isFixedBooking($scope.booking);
        },
    };
}
